import React, { useEffect, useState } from "react";
import { useUser } from "../../../context/UserContext";
import { ProductService } from "../../../services/product.service";
import { Product } from "../../../commonTypes";
import ProductCard from "../../product/ProductCard";
import AccountSubHeader from "../accountSubHeader/accountSubheader";

import styles from "./userFavorites.module.css";

const UserFavorites = (): JSX.Element => {
  const { userFavorites } = useUser();
  const [favoriteProducts, setFavoriteProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch favorite products when userFavorites changes
  useEffect(() => {
    const fetchFavorites = async () => {
      if (!userFavorites || userFavorites.length === 0) {
        setFavoriteProducts([]);
        return;
      }

      setIsLoading(true);
      try {
        const products = await ProductService.getProductsByIds(userFavorites);
        setFavoriteProducts(products);
      } catch (error) {
        console.error("Error fetching favorites:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFavorites();
  }, [userFavorites]);

  return (
    <div>
      <AccountSubHeader title="My favourites" />
      <div>
        {isLoading ? (
          <p>Loading...</p>
        ) : userFavorites.length < 1 ? (
          <p>No Favorites found</p>
        ) : (
          <div className={styles.products}>
            {favoriteProducts.map((product) => (
              <div
                className={styles.productItem}
                key={`favorite_item_${product.id}`}
              >
                <ProductCard product={product} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserFavorites;
